import React, { ReactNode, useEffect } from 'react'
import { createPortal } from 'react-dom'

import cn from 'classnames'

import styles from './Modal.module.scss'

interface ModalProps {
  // setIsActiveModal: (value: boolean) => void
  className?: string
  children: ReactNode
}

const Modal = ({
  // setIsActiveModal,
  className,
  children,
}: ModalProps) => {
  const modal = document.getElementById('modal')

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return (
    modal &&
    createPortal(
      <div className={cn(styles.modal)}>
        <div className={cn(styles.wrapper, className)}>{children}</div>
      </div>,
      modal,
    )
  )
}

export default Modal
